import axios from '../axios'

const postRegisterAvailableApi = async (startAt, endAt, registerAt, repeatType, endAtRule, repeatOn) => {
    return await axios.post(`api/teacher/events/available`, { startAt, endAt, registerAt, repeatType, endAtRule, repeatOn })
}

export default postRegisterAvailableApi
